import { Injectable } from "@angular/core";
import { select, Store } from "@ngrx/store";
import {
  IAMAccountPasswordUpdateCmd,
  IAMAccountSignInCmd
} from "@youm-front/iam-account/domain";
import { IAMAccountActions } from "../actions";
import { IAMAccountSelectors } from "../selectors";

@Injectable()
export class IAMAccountFacade {
  passwordUpdateIsLoading$ = this.store.pipe(
    select(IAMAccountSelectors.passwordUpdateIsLoading)
  );
  signInIsLoading$ = this.store.pipe(
    select(IAMAccountSelectors.signInIsLoading)
  );

  constructor(private readonly store: Store) {}

  iamAccountPasswordUpdate(
    iamAccountPasswordUpdateCmd: IAMAccountPasswordUpdateCmd
  ) {
    return this.store.dispatch(
      IAMAccountActions.iamAccountPasswordUpdate({
        iamAccountPasswordUpdateCmd
      })
    );
  }

  iamAccountSignIn(iamAccountSignInCmd: IAMAccountSignInCmd) {
    return this.store.dispatch(
      IAMAccountActions.iamAccountSignIn({ iamAccountSignInCmd })
    );
  }
}
